import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { MinusIcon, SuccessIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import styled from 'styled-components';
import ProductFeatureLongLimit from './ProductFeatureLongLimit';
import TranslatedFeature from './TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureTableCellWrapper = styled.td.withConfig({
  displayName: "FeatureTableCell__FeatureTableCellWrapper",
  componentId: "sc-2b7jps-0"
})(({
  theme
}) => ({
  padding: `${theme.space['300']}`
}));
const SuccessCheckDiv = styled.div.withConfig({
  displayName: "FeatureTableCell__SuccessCheckDiv",
  componentId: "sc-2b7jps-1"
})(({
  theme
}) => ({
  fontSize: `${theme.space['250']} !important`
}));
const ScreenReaderFeatureLabel = styled.span.withConfig({
  displayName: "FeatureTableCell__ScreenReaderFeatureLabel",
  componentId: "sc-2b7jps-2"
})(({
  theme
}) => ({
  position: 'absolute !important',
  top: `${theme.space['0']} !important`,
  width: `${theme.space['25']} !important`,
  height: `${theme.space['25']} !important`,
  padding: `${theme.space['0']} !important`,
  overflow: 'hidden !important',
  clip: 'rect(0, 0, 0, 0) !important'
}));
const FeatureTableCell = ({
  feature,
  showTooltip = true,
  apiName,
  onlyShowCurrentLongLimit
}) => {
  const hasDefaultLimit = Object.keys(feature.shouldUseDefaultLimits).some(key => key.includes(apiName));
  const hasShortLimit = Object.keys(feature.shortLimits).some(key => key.includes(apiName) && !!feature.shortLimits[key]);
  const featureAvailable = hasDefaultLimit || hasShortLimit;
  if (!featureAvailable) return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: /*#__PURE__*/_jsx(MinusIcon, {
      "aria-label": I18n.text('upgrades.featureTable.screenReader.featureUnavailable')
    })
  });
  const shouldShowLongLimitContent = () => {
    if (!Object.keys(feature.longLimits).length) {
      return false;
    }
    return onlyShowCurrentLongLimit ? !!feature.longLimits[apiName] : !!Object.keys(feature.longLimits).find(innerApiName => {
      return !!feature.longLimits[innerApiName];
    });
  };
  const longLimitContent = shouldShowLongLimitContent() ? /*#__PURE__*/_jsx(ProductFeatureLongLimit, {
    feature: feature,
    apiName: apiName,
    onlyShowCurrentLongLimit: onlyShowCurrentLongLimit
  }) : null;
  const hasTooltip = showTooltip && longLimitContent !== null;
  const shortLimitContent = hasShortLimit ? /*#__PURE__*/_jsx("div", {
    tabIndex: -1,
    children: /*#__PURE__*/_jsx(TranslatedFeature, {
      apiName: apiName,
      feature: feature,
      attribute: "shortLimits"
    })
  }) : /*#__PURE__*/_jsxs(SuccessCheckDiv, {
    children: [/*#__PURE__*/_jsx(IconCircle, {
      icon: SuccessIcon,
      color: "fill-surface-default",
      backgroundColor: "icon-core-default",
      borderWidth: "0"
    }), /*#__PURE__*/_jsx(ScreenReaderFeatureLabel, {
      children: I18n.text('upgrades.featureTable.screenReader.featureAvailable')
    })]
  });
  return /*#__PURE__*/_jsx(FeatureTableCellWrapper, {
    children: hasTooltip ? /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: longLimitContent,
      children: shortLimitContent
    }) : shortLimitContent
  });
};
export default FeatureTableCell;